import './home.scss';
import { GoCalendar } from 'react-icons/go';
import { GiPositionMarker, GiMoneyStack } from 'react-icons/gi';
import { BiTimeFive } from 'react-icons/bi';
import { IoMdArrowRoundForward, IoMdArrowRoundBack } from 'react-icons/io';
import { EPage, Section, Heading } from '@sifrovacihra/shared-ui';
import { useNavigate } from 'react-router-dom';
import { changePage } from '../../utils';


export const Home = () => {

    const navigate = useNavigate()

    return (
        <>
            <Heading
                headline="Táborská šifrovačka"
                weight={1}
            />

            <Section delimeter={true}>
                6. ročník šiftu je za námi! Moc děkujeme všem týmům za účast a gratulujeme vítězům! Těšíme se na vás zase příští rok, kdy se můžete těšit na další porci zábavy a šifrovacích výzev. Na stránce <span onClick={() => changePage(EPage.STATS, navigate)} className='href'>Statistiky</span> si můžete prohlédnout, jak se vám letos vedlo a porovnat své výsledky s ostatními týmy. Šifry i jejich řešení si můžete prohlédnout na stránce <span onClick={() => changePage(EPage.HISTORY, navigate)} className='href'>Minulé ročníky</span>.
            </Section>

            <Section centered={true}>
                <div className='motivation'>
                    <p>Chceš zažít dobrodružství a pobavit se?</p>
                    <p>Nebojíš se žádné šifrovací výzvy? </p>
                    <p>Tak jsi tu správně!</p>
                </div>
            </Section>
            <Section centered={true} delimeter={true}>
                <div className='info'>
                    <div className='info__box'>
                        <GoCalendar size='5rem' color='#ffcc00' className='info__box__icon'/>
                        <span className='info__box__text'>23. května 2026</span>
                    </div>
                    <div className='info__box'>
                        <BiTimeFive size='5rem' color='#ffcc00' className='info__box__icon' />
                        <span className='info__box__text'>9:00 - 17:00</span>
                    </div>
                    <div className='info__box'>
                        <GiPositionMarker size='5rem' color='#ffcc00' className='info__box__icon' />
                        <span className='info__box__text'>Tábor a okolí</span>
                    </div>
                    <div className='info__box'>
                        <GiMoneyStack size='5rem' color='#ffcc00' className='info__box__icon' />
                        <span className='info__box__text'>Startovné: 300 Kč/tým</span>
                    </div>
                </div>
            </Section>
            <Section>
                {/*
                <div className='poster'>
                    <a href="https://www.sifrovacihra.cz/sift/2025/letacek2025.jpg" download> <IoMdDownload /> Propagační letáček </a>
                </div>
                */}
            </Section>
            <Section>
                <Heading
                    headline="Pro koho je akce určená?"
                    weight={3}
                    icon={<IoMdArrowRoundForward color='#ffcc00' size='1.5rem' /> }
                />
                <p>Přihlašovat se mohou <b>2 až 5členné týmy</b>, které se nebojí výzev a chtějí si užít trochu legrace. I letos si můžete při přihlášení <b>zvolit kategorii Začátečníci nebo Pokročilí</b>. Kategorie Začátečníci je vhodná i pro školáky bez ohledu na věk (s dospělým doprovodem).</p>

                <Heading
                    headline="Jak se mohu přihlásit?"
                    weight={3}
                    icon={<IoMdArrowRoundForward color='#ffcc00' size='1.5rem' />}
                />
                <p>Přihlaš svůj tým zde na webu nejpozději do půlnoci 19. května. <strong>S přihlášením neváhej, počet týmů je omezen!</strong> Před hrou si určitě neopomeň prostudovat <span onClick={() => changePage(EPage.RULES, navigate)} className='href'>pravidla hry</span>.</p>

                <div onClick={() => changePage(EPage.REGISTRATION, navigate)} className='registration'>
                        <IoMdArrowRoundForward color='#ffcc00' size='1.5rem' />Přihlásit nový tým<IoMdArrowRoundBack color='#ffcc00' size='1.5rem' />
                </div>

                <Heading
                    headline="ŠifT jsem šel loni, co bude letos jiné?"
                    weight={3}
                    icon={<IoMdArrowRoundForward color='#ffcc00' size='1.5rem' />}
                />
                <p>Samozřejmě šifry a trasa! A kromě toho jsme letos učnili několik změn, abyste si hru mohli užít lépe:</p>
                <ul>
                    <li>Prodloužili jsme čas hry, abyste nebyli nuceni chvátat do cíle, pokud nemusíte. Nicméně hra je koncipována tak, <strong>aby většina týmů došla do 14:00</strong>, kdy bude vyhlášení.</li>
                    <li><strong>Týmy mohou být až 5členné</strong>, startovné se platí za tým bez ohledu na počet jeho členů</li>
                    <li>Trasa bude letos kratší a méně fyzicky náročná (v obou kategoriích)</li>
                </ul>

                <Heading
                    headline="Co můžu čekat?"
                    weight={3}
                    icon={<IoMdArrowRoundForward color='#ffcc00' size='1.5rem' />}
                />
                <p>Těš se na den plný akce a zábavy! Při zahájení hry dostaneš šifru, jejíž rozluštění tě zavede na další stanoviště, kde najdeš další šifru, a tak pokračuješ dál. Ale pozor, běží ti čas!</p>

                <p>Šifrovací hry jsou netuctovou zábavou a výzvou, které každoročně propadají další a další milovníci záhad a dobrodružství. Spojují v sobě radost ze hry a soutěžení, luštění důmyslných šifer, překonání sama sebe a objevování zajímavých míst, kam by ses třeba normálně nikdy nepodíval. A to všechno v partě kamarádů.</p>

                <p>Pokud stále tápeš, co to vlastně šifrovačka je a v čem to spočívá, můžeš si o tom přečíst víc <a href="https://www.sifrovacky.cz" target="_blank" rel="noreferrer">zde</a>. Anebo se podívej na řešení šifer z minulých ročníků.</p>

                <Heading
                    headline="Jak náročná bude trasa?"
                    weight={3}
                    icon={<IoMdArrowRoundForward color='#ffcc00' size='1.5rem' />}
                />
                <p>Pro kategorii Začátečníci bude trasa dlouhá přibližně 5 kilometrů a bude obsahovat 7 stanovišť + cíl. Trasa je (až na nějaké schody, které je nutné přenést/objet) sjízdná s kočárkem.</p>
                <p>Pokročilí budou muset zdolat trasu dlouhou necelých 6 kilometrů a navštíví 9 stanovišť + cíl. Letos by to s (alespoň trochu terénním) kočárkem neměl být problém :)</p>

                <Heading
                    headline="Kdo hru organizuje?"
                    weight={3}
                    icon={<IoMdArrowRoundForward color='#ffcc00' size='1.5rem' />}
                />
                <p>ŠifT organizuje Městská knihovna Tábor. Šifry a web vytváří Martin Mach - (spolu)organizátor několika dalších šifrovaček (nejen) na webu sifrovacihra.cz.</p>

                <p>Pokud máte nějaké dotazy, na které jste zde nebo v <span onClick={() => changePage(EPage.RULES, navigate)} className='href'>pravidlech</span> nenašli odpověď, obraťte se na nás emailem: <a href="mailto:ivana.starkova@mkta.cz">ivana.starkova@mkta.cz</a>.</p>
            </Section>

            <Section centered={true}>
                <Heading
                    headline="Poděkování"
                    weight={3}
                    icon={<IoMdArrowRoundForward color='#ffcc00' size='1.5rem' />}
                />
                <p>Děkujeme společnosti <strong>Mindok</strong>, která nám věnovala několik stolních her jako ceny pro vítěze!</p>
                <div className='sponsor'>
                    <a href="https://www.mindok.cz" target="_blank" rel="noreferrer">
                        <img src="/logo_mindok.png" alt="Logo Mindok" />
                    </a>
                </div>
            </Section>

        </>
    )
}
